// for GA events, they want every first letter of every word to be uppercase
// from https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
function toTitleCase(s) {
  if (typeof s !== 'string') {
    return '';
  }
  return s
    .split(' ')
    .filter((w) => w.length > 0)
    .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
    .join(' ');
}

export default {
  toTitleCase
};
